// extracted by mini-css-extract-plugin
export default {"searchResultItem":"search-result-item_searchResultItem__xwmms"};